import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openUploadedFile, downloadUploadedFile } from 'store/forms/actions';
import { ReactComponent as FileExcel } from 'assets/icons/file-excel.svg';
import { ReactComponent as FileWord } from 'assets/icons/file-word.svg';
import { ReactComponent as FilePdf } from 'assets/icons/file-pdf.svg';
import { ReactComponent as DownloadIcon } from 'assets/icons/download_blue.svg';
import { isNil } from 'lodash';

const DownloadSingleFile = ({ item, index, group, withOpen=false }) => {
  const documents = useSelector(state => state.forms[group]) //[item.fileCode]
  const documentId = !isNil(documents) && !isNil(documents[item.fileCode]) && !isNil(documents[item.fileCode][index]) ?
                    documents[item.fileCode][index] : 
                    null;

  const dispatch = useDispatch();
  
  return (
    !isNil(documentId) && !isNil(documentId.id) && (
     <div className='file-download-container'>
       <div key={index} className="download-file">
             <div className="d-flex justify-content-end">
                 { withOpen &&
                   <div
                     className="open-file"
                     onClick={(e) => e.stopPropagation(
                       dispatch(
                         documentId.simpleType === 'pdf'
                           ? openUploadedFile(documentId)
                           : downloadUploadedFile(documentId)
                       ))
                     }
                   >
                   Άνοιγμα
                   </div>
                 }
                 <div
                   className="d-flex"
                   onClick={(e) => e.stopPropagation(dispatch(downloadUploadedFile(documentId)))}
                 >
                   <DownloadIcon className="download-file__icon" />
                   <div className="download-label">Download</div>
                 </div>
               </div>
             </div>
       </div>
   )
 )     
};

export default DownloadSingleFile;